import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, MaybeAsync, Resolve, Router, RouterStateSnapshot } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { HttpClient, HttpXhrBackend } from "@angular/common/http";
import { map } from "rxjs";
import { ELegalDocType } from "@shared/enums/legal-doc-type.enum";

@Injectable({
  providedIn: "root",
})
export class LegalDocumentResolver implements Resolve<SafeHtml> {
  private readonly translate = inject(TranslateService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly router = inject(Router);
  private readonly http = new HttpClient(new HttpXhrBackend({ build: (): XMLHttpRequest => new XMLHttpRequest() }));

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<SafeHtml> {
    const documentType = route.queryParams["type"] as ELegalDocType;

    if (!documentType || !Object.values(ELegalDocType).includes(documentType)) {
      void this.router.navigate(["/home"]);
      return "";
    }

    return this.http.get(`assets/legal/${this.translate.currentLang}/${documentType}.html`, { responseType: "text" }).pipe(
      map((value) => {
        return this.sanitizer.bypassSecurityTrustHtml(value);
      }),
    );
  }
}
